const groupVpsHostingIncludedFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title');
  const itemFields = fields
    .filter((field) => /^item-\d+-text$/.test(field.key))
    .sort((a, b) => a.sortOrder - b.sortOrder);

  return { introFields, itemFields };
};

export default groupVpsHostingIncludedFields;
